import React from "react";
import Select from 'react-select'

export function DropDown(props) {

  // function items() {
  //   return props.values.map((name, i) => {
  //     const nameStr = `Rule ${name}`
  //     return <option key={i} value={name}>{nameStr}</option>
  //   })
  // }
  
  function items() {
    return props.values.map((name, i) => {
      const nameStr = `Rule ${name}`
      return {value: name, label: nameStr}
    })
  }

  const options = items()
  return <Select options={options} 
                 value={options.filter(option => option.value === props.value )} 
                 onChange={props.onChangeDropDown}/>
}
